import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgAutoDrawCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 0 18 24" {...props}>
      <path
        d="M13 5a2 2 0 011.854 1.248 7.013 7.013 0 014.898 4.898 2 2 0 010 3.708 7.013 7.013 0 01-4.898 4.898 2 2 0 01-3.708 0 7.013 7.013 0 01-4.898-4.898 2 2 0 010-3.708 7.015 7.015 0 014.898-4.898A2 2 0 0113 5zm1.56 3.248l-.05.064a2 2 0 01-3.071-.062 5.004 5.004 0 00-3.19 3.19 1.995 1.995 0 01.001 3.121 5.004 5.004 0 003.19 3.19 1.995 1.995 0 013.121-.001 5.004 5.004 0 003.19-3.19 1.995 1.995 0 01-.001-3.121 5.004 5.004 0 00-3.19-3.19zM6.334 3v1.666H8v1.667H6.333V8H4.667l-.001-1.667H3V4.667l1.666-.001V3h1.667z"
        fill="currentColor"
      />
      <path
        d="M11.27 15.7l.517-1.269h2.394l.517 1.27H16L13.574 10h-1.148L10 15.7h1.27zm2.466-2.368h-1.504l.752-1.836.752 1.836z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('AutoDrawCircle')(SvgAutoDrawCircle);
